import React, { useEffect, useState } from 'react';

import useUsers from '../../context/UsersContext';
import useConfig from '../../context/ConfigContext';

import { Box } from '@mui/material';
import { sxConfig } from './ProductionGenerator.style';
import ProductionGeneratorTable from './ProductionGeneratorTable';
import ProductionGeneratorTree from './ProductionGeneratorTree';
import ProductionGeneratorNewProdTable from './ProductionGeneratorNewProdTable';

const ProductionGeneratorPage = () => {
  const { getUser, user } = useUsers();
  const { config, getConfig } = useConfig();

  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [removedItem, setRemovedItem] = useState(null);
  const [refetchTable, setRefetchTable] = useState(false);
  const [sourceData, setSourceData] = useState([]);
  const [treeData, setTreeData] = useState([]);
  const [expandedItems, setExpandedItems] = useState([]);

  useEffect(() => {
    if (!Object.keys(user).length) getUser();
    if (!Object.keys(config).length) getConfig();
  }, []);

  return (
    <Box sx={sxConfig.containerBox}>
      <Box sx={sxConfig.formBox}>
        <ProductionGeneratorTable
          selectedRowsState={{ selectedRows, setSelectedRows }}
          selectedItemsState={{ selectedItems, setSelectedItems }}
          removedItemState={{ removedItem, setRemovedItem }}
          refetchState={{ refetchTable, setRefetchTable }}
          treeDataState={{ treeData, setTreeData }}
          sourceDataState={{ sourceData, setSourceData }}
          expandedItemsState={{ expandedItems, setExpandedItems }}
        />
        <ProductionGeneratorTree
          sourceDataState={{ sourceData, setSourceData }}
          treeDataState={{ treeData, setTreeData }}
          expandedItemsState={{ expandedItems, setExpandedItems }}
        />
        <ProductionGeneratorNewProdTable
          removedItemState={{ removedItem, setRemovedItem }}
          refetchState={{ refetchTable, setRefetchTable }}
          selectedItemsState={{ selectedItems, setSelectedItems }}
          selectedRowsState={{ selectedRows, setSelectedRows }}
          sourceDataState={{ sourceData, setSourceData }}
          treeDataState={{ treeData, setTreeData }}
        />
      </Box>
    </Box>
  );
};

export default ProductionGeneratorPage;
